import React from 'react'

export default function ConfirmButton(props) {
    return (
        <button className={props.className + (props.enabled ? '' : 'btn-disabled')} style={props?.style || {}}id={props.id} onClick={props.onClick} type={props.type ?? "button"}>{props.text}</button>
    )
}
